/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PatientImage/view.blocks to change it.
import * as fromAggregate from 'Simple/Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromFormat from 'Data/format.js'
import * as fromHelpers from './helpers.js'
import PatientImageCard from 'DesignSystem/PatientImageCard/index'
import PatientImageExample from 'DesignSystem/PatientImageExample/index'
import React from 'react'
import TysiaCheckboxInput from 'DesignSystem/TysiaCheckbox/TysiaCheckboxInput/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function PatientImage({
  children,
  viewPath = "/DesignSystem/CaptureImageSeries/Content/Active/Content/Images/ImageSlot/ImageAction/PatientImage"
  
}) {
let imageStatusValueData = fromData.useDataValue({ viewPath,
context: 'image',
path: 'status',
})
let constantData = 'uploading'
let aggregateData = fromAggregate.equals(imageStatusValueData, constantData)
let imageSlotKeyValueData = fromData.useDataFormat({ viewPath,
context: 'image',
path: 'slot_key',
format: fromFormat.getPatientImageName,
})
let imageSlotKeyValueData1 = fromData.useDataValue({ viewPath,
context: 'image',
path: 'slot_key',
})
let imageUrlValueData = fromData.useDataValue({ viewPath,
context: 'image',
path: 'url',
})
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
let settingsIntraoralMobileCaptureExamplesEnabledValueData = fromData.useDataValue({ viewPath,
context: 'settings',
path: 'intraoral_mobile_capture_examples_enabled',
})
let imagesRequestParentCompanyUuidValueData = fromData.useDataValue({ viewPath,
context: 'images_request',
path: 'parent_company_uuid',
})
let imageSlotKeyValueData2 = fromData.useDataFormat({ viewPath,
context: 'image',
path: 'slot_key',
format: fromFormat.getPatientImageName,
})
let imageSlotKeyValueData3 = fromData.useDataValue({ viewPath,
context: 'image',
path: 'slot_key',
})
let imageStatusValueData1 = fromData.useDataValue({ viewPath,
context: 'image',
path: 'status',
})
let constantData1 = 'done'
let aggregateData1 = fromAggregate.equals(imageStatusValueData1, constantData1)
let imageStatusValueData2 = fromData.useDataValue({ viewPath,
context: 'image',
path: 'status',
})
let constantData2 = 'error'
let aggregateData2 = fromAggregate.equals(imageStatusValueData2, constantData2)
  return (<React.Fragment
>
<div
  data-testid="PatientImage.Vertical"
  data-view-path={viewPath}
 style={{'--o-1-ZQLfNn': aggregateData ? 0.75 : 1}}
 className={`views-block ${styles.Vertical}`}
>
<PatientImageCard
  viewPath={`${viewPath}/PatientImageCard`}
 data="image.slot_key"
 format="/Data/format.js getPatientImageName"
 label={imageSlotKeyValueData}
 data="image.slot_key"
 slot_key={imageSlotKeyValueData1}
 data="image.url"
 url={imageUrlValueData}
 onClick={onClick}
/>
<PatientImageExample
  viewPath={`${viewPath}/PatientImageExample`}
 data="settings.intraoral_mobile_capture_examples_enabled"
 show_example={settingsIntraoralMobileCaptureExamplesEnabledValueData}
 data="images_request.parent_company_uuid"
 organization_id={imagesRequestParentCompanyUuidValueData}
 data="image.slot_key"
 format="/Data/format.js getPatientImageName"
 label={imageSlotKeyValueData2}
 data="image.slot_key"
 slot_key={imageSlotKeyValueData3}
/>
<div
  data-testid="PatientImage.Vertical:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical1}`}
>
<TysiaCheckboxInput
  viewPath={`${viewPath}/TysiaCheckboxInput`}
 data="image.status"
 data="'done'"
 aggregate="/Simple/Data/aggregate.js equals"
 value={aggregateData1}
 data="image.status"
 data="'error'"
 aggregate="/Simple/Data/aggregate.js equals"
 invalid={aggregateData2}
/>
</div>
</div>
{children}
</React.Fragment>)
}